import { Component } from '@angular/core';
import { CounselorNav } from '../counselor-nav/counselor-nav';
import { MessagesThreadPage } from '../../../common/messages-thread-page/messages-thread-page';

/**
 * Thin shell for the counselor Messages route — renders the counselor nav
 * and this role's page-level layout, then embeds the shared thread/composer
 * component that both roles use identically.
 */
@Component({
  selector: 'app-counselor-messages-page',
  standalone: true,
  imports: [CounselorNav, MessagesThreadPage],
  templateUrl: './counselor-messages-page.html',
  styleUrls: ['./counselor-messages-page.css'],
})
export class CounselorMessagesPage {}
